export const iconFontAwesomeTransportationSnowplow = (
	<i className="fa-solid fa-snowplow"></i>
);
